// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RsI6","title":"styles_title__1udmr"};